<template>
  <div>
    <!--附加服务维护  -->
    <baseBreadcrumb :page="$t('message.LogisticsAdditionalServiceMaintenance')"
      :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="type" type="card" @tab-click="optionList">
          <!-- 已确认 -->
          <el-tab-pane :label="item.value" :name="item.key + ''" v-for="item in typeList" :key="item.key">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="btn">
        <!-- 排序编号设置 -->
        <el-button type="primary" size="small" @click="showSort" v-if="isAuth(429)">
          {{ $t("message.sortNumberSetting") }}
        </el-button>
        <!-- 新增 -->
        <el-button type="primary" size="small" @click="add" v-if="isAuth(426)">
          {{ $t("message.add") }}
        </el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 系统编号 -->
          <el-table-column align="center" :label="$t('message.systemNumber')" prop="sort" width="80">
          </el-table-column>
          <!-- 附加服务中文名 -->
          <el-table-column align="center" :label="$t('message.additionalServicesChinese')" prop="name">
          </el-table-column>
          <!-- 附加服务日语名 -->
          <el-table-column align="center" :label="$t('message.additionalServicesJapanese')" prop="name_translate">
          </el-table-column>
          <!-- 计费规则 -->
          <el-table-column align="center" :label="$t('message.accountingRules')" prop="rowNumber">
            <template slot-scope="scope">
              <!--  option单价*数量 商品单价*百分比-->
              {{ scope.row.price_type == 0 ?
      $t("message.optionNnitPriceQuantity") : $t("message.unitpriceofgoodsPercentage") }}
            </template>
          </el-table-column>
          <!-- 默认收费标准 -->
          <el-table-column align="center" :label="$t('message.defaultChargeRate')" prop="rowNumber">
            <template slot-scope="scope">
              <span> {{ scope.row.price }} {{ scope.row.unit }} </span>
            </template>
          </el-table-column>
          <!-- 问题产品自动计算 -->
          <el-table-column align="center" :label="$t('message.problemProductsAreAutomaticallyCalculated')"
            prop="rowNumber">
            <template slot-scope="scope">
              {{ scope.row.auto_calculate == 0 ? $t("message.noAutomaticCalculation") :
      $t("message.automaticCalculation")
              }}
            </template>
          </el-table-column>
          <!-- 默认ICON -->
          <el-table-column align="center" :label="$t('message.defaultICON')">
            <template slot-scope="scope">
              <img :src="scope.row.icon" alt="" style="width: 100px; height: 100px;" v-if="scope.row.icon">
            </template>
          </el-table-column>
          <!-- 选中后ICON -->
          <el-table-column align="center" :label="$t('message.selectionICON')">
            <template slot-scope="scope">
              <img :src="scope.row.icon_selected" alt="" style="width: 100px; height: 100px;"
                v-if="scope.row.icon_selected">
            </template>
          </el-table-column>
          <!-- option图片 -->
          <el-table-column align="center" :label="$t('message.optionPic')" prop="image">
            <template slot-scope="scope">
              <img :src="scope.row.image" alt="" style="width: 100px; height: 100px;" v-if="scope.row.image">
            </template>
          </el-table-column>
          <!-- option视频 -->
          <el-table-column align="center" :label="$t('message.optionVideo')" prop="video" width="150">
            <template slot-scope="scope">
              <video :src="scope.row.video" style="width: 150px; height: 100px;" v-if="scope.row.video" controls>
              </video>
            </template>
          </el-table-column>
          <!-- 备注说明 -->
          <el-table-column align="center" :label="$t('message.remarks')" prop="remark" width="300">
          </el-table-column>
          <!-- 状态 -->
          <!-- <el-table-column align="center" :label="$t('message.type')" prop="">
          </el-table-column> -->
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="150">
            <template slot-scope="scope">
              <!-- 修改 -->
              <el-button size="mini" type="success" @click="edit(scope.row)" v-if="isAuth(427)">
                {{ $t("message.edit") }}
              </el-button>
              <!-- 删除 -->
              <el-button size="mini" type="success" @click="optionDelete(scope.row.id)" class="dark" v-if="isAuth(428)">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增 修改-->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="1400px" center>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <!-- 附加服务中文名 -->
          <el-form-item :label="$t('message.additionalServicesChinese')" prop="name">
            <el-input v-model="ruleForm.name" v-if="isAdd"></el-input>
            <span v-else>{{ ruleForm.name }}</span>
          </el-form-item>
          <!-- 附加服务日语名 -->
          <el-form-item :label="$t('message.additionalServicesJapanese')" prop="name_translate">
            <el-input v-model="ruleForm.name_translate"></el-input>
          </el-form-item>
          <!-- 计费规则 -->
          <el-form-item :label="$t('message.accountingRules')" prop="price_type">
            <el-radio-group v-model="ruleForm.price_type">
              <el-radio :label="0">{{ $t("message.optionNnitPriceQuantity") }}</el-radio>
              <el-radio :label="1">{{ $t("message.unitpriceofgoodsPercentage") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 默认收费标准 -->
          <el-form-item :label="$t('message.defaultChargeRate')" prop="price">
            <el-input v-model="ruleForm.price" type="number"></el-input>
          </el-form-item>
          <!-- 单位 -->
          <el-form-item :label="$t('message.units')" prop="unit">
            <el-input v-model="ruleForm.unit"></el-input>
          </el-form-item>
          <!-- 问题产品自动计算 -->
          <el-form-item :label="$t('message.problemProductsAreAutomaticallyCalculated')" prop="auto_calculate">
            <el-radio-group v-model="ruleForm.auto_calculate">
              <el-radio :label="0">{{ $t("message.noAutomaticCalculation") }}</el-radio>
              <el-radio :label="1">{{ $t("message.automaticCalculation") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 备注说明 -->
          <el-form-item :label="$t('message.remark')" prop="remark">
            <el-input v-model="ruleForm.remark" type="textarea"></el-input>
          </el-form-item>
          <!-- 默认ICON -->
          <el-form-item :label="$t('message.defaultICON')">
            <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :on-success="handleAvatarSuccessIcon" :before-upload="beforeAvatarUpload">
              <img v-if="ruleForm.icon" :src="ruleForm.icon" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 选中后ICON -->
          <el-form-item :label="$t('message.selectionICON')">
            <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :on-success="handleAvatarSuccessIcon_selected" :before-upload="beforeAvatarUpload">
              <img v-if="ruleForm.icon_selected" :src="ruleForm.icon_selected" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- option图片 -->
          <el-form-item :label="$t('message.optionPic')">
            <el-input v-model="ruleForm.image"></el-input>
          </el-form-item>
          <!-- option视频 -->
          <el-form-item :label="$t('message.optionVideo')">
            <el-input v-model="ruleForm.video"></el-input>
          </el-form-item>
          <!-- 日文说明 -->
          <el-form-item label="日文说明">
            <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.desc" :options="quillOption">
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="addDialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="optionStore" v-if="isAdd">
          {{ $t("message.save") }}
        </el-button>
        <!-- 修改 -->
        <el-button type="primary" @click="optionUpdate" v-else>
          {{ $t("message.edit") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 排序编号设置: -->
    <el-dialog :title="$t('message.sortNumberSetting')" :close-on-click-modal="false" :visible.sync="sortDialogVisible"
      width="600px" center>
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" border style="width: 100%">
        <!-- 系统编号 -->
        <el-table-column align="center" :label="$t('message.systemNumber')" prop="sort" width="80">
        </el-table-column>
        <!-- 附加服务中文名 -->
        <el-table-column align="center" :label="$t('message.additionalServicesChinese')" prop="name">
        </el-table-column>
        <!-- 附加服务日语名 -->
        <el-table-column align="center" :label="$t('message.additionalServicesJapanese')" prop="name_translate">
        </el-table-column>
        <!-- 排序编号 -->
        <el-table-column align="center" :label="$t('message.sortNumber')">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.sorts" onfocus="this.select()"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="sortDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="optionUpdateSort">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      quillOption: quillConfig,
      type: '0',
      typeList: [],
      tableData: [],
      addDialogVisible: false,
      isAdd: false,
      ruleForm: {},
      rules: {
        name: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        name_translate: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        price_type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        auto_calculate: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      title: "",
      //   排序
      sortDialogVisible: false,
    };
  },
  created() {
    this.$api.siteConfiguration.optionTypeList().then(res => {
      this.typeList = res.data
      console.log(res);
    })
    this.optionList();
  },
  methods: {
    optionList() {
      this.$api.siteConfiguration.optionList({ type: this.type, need_desc: true, }).then((res) => {
        res.data.forEach((item) => {
          item.sorts = item.sort;
        });
        this.tableData = res.data;
      });
    },
    // 新增
    add() {
      this.title = this.$t("message.add");
      this.ruleForm = {
        name: "",
        name_translate: "",
        price: "",
        price_type: "",
        unit: "",
        is_overstep: "",
        auto_calculate: "",
        remark: "",
        sort: 0,
        is_overstep: 1,
        type: this.type,
        icon: '',
        icon_selected: '',
        image: '',
        video: '',
        desc: '',
      };
      this.addDialogVisible = true;
      this.isAdd = true;
    },
    // 新增option
    optionStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration.optionStore(this.ruleForm).then((res) => {
            if (res.code != 0) return this.$message(res.msg);
            this.addDialogVisible = false;
            this.optionList();
          });
        }
      });
    },
    // 显示修改
    edit(item) {

      this.ruleForm = JSON.parse(JSON.stringify(item));
      this.addDialogVisible = true;
      this.isAdd = false;
      this.title = this.$t("message.edit");
    },
    // 修改
    optionUpdate() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .optionUpdate(this.ruleForm)
            .then((res) => {
              if (res.code != 0) return this.$message(res.msg);
              this.addDialogVisible = false;
              this.optionList();
            });
        }
      });
    },
    // 删除
    optionDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.optionDelete({ id }).then((res) => {
            this.$message.success(res.msg);

            this.optionList();
          });
        })
        .catch(() => { });
    },
    // 显示排序
    showSort() {
      this.sortDialogVisible = true;
    },
    // 排序
    optionUpdateSort() {
      let datas = {
        list: [],
      };
      let flag = this.tableData.every((item) => item.sorts != "");
      if (!flag) return this.$message.error("有option未排序");
      this.tableData.forEach((item) => {
        datas.list.push({
          name: item.name,
          sort: item.sorts,
          id: item.id,
        });
      });
      this.$api.siteConfiguration.optionUpdateSort(datas).then((res) => {
        this.$message.success(res.msg);
        this.sortDialogVisible = false;
        this.optionList();
      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    //默认icon
    handleAvatarSuccessIcon(file) {
      this.ruleForm.icon = file.data
      this.$forceUpdate()
    },
    //选中的icon
    handleAvatarSuccessIcon_selected(file) {
      this.ruleForm.icon_selected = file.data
      this.$forceUpdate()
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
<style lang='scss' scoped>
.btn {
  text-align: right;
  margin-bottom: 20px;
}

.form {
  padding: 0 20px;
}

/deep/.ql-editor {
  height: 300px !important;
}
</style>